export default function () {
    const runtimeConfig = useRuntimeConfig();
    return runtimeConfig.public.backApiUrl;
  }
  